import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import { getNavigation } from '@plone/volto/actions/navigation/navigation';
import { getBaseUrl } from '@plone/volto/helpers/Url/Url';
import { hasApiExpander } from '@plone/volto/helpers/Utils/Utils';
import config from '@plone/volto/registry';
import Button from '../..//Button';
import Icon from '../../Icon';
import MobileNavigationBody from './MobileNavigationBody';

const messages = defineMessages({
  closeMobileMenu: {
    id: 'Close menu',
    defaultMessage: 'Close menu',
  },
  openMobileMenu: {
    id: 'Open menu',
    defaultMessage: 'Open menu',
  },
  menu_label: {
    id: 'Main navigation menu',
    defaultMessage: 'Main navigation menu',
  },
});

const Navigation = (props) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const { pathname } = props;
  const [isMobileMenuOpen, setisMobileMenuOpen] = useState(false);
  const token = useSelector((state) => state.userSession.token, shallowEqual);
  const items = useSelector((state) => state.navigation.items, shallowEqual);
  const lang = useSelector((state) => state.intl.locale);

  useEffect(() => {
    const { settings } = config;
    if (!hasApiExpander('navigation', getBaseUrl(pathname))) {
      dispatch(getNavigation(getBaseUrl(pathname), settings.navDepth));
    }
  }, [pathname, token, dispatch]);

  const toggleMobileMenu = () => {
    setisMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    if (!isMobileMenuOpen) {
      return;
    }
    setisMobileMenuOpen(false);
  };

  return (
    <nav
      className="site-navigation mobile"
      id="navigation-mobile"
      aria-label="navigation"
    >
      <div className="mobile-trigger">
        <Button
          circle
          link
          onClick={toggleMobileMenu}
          title={intl.formatMessage(
            messages[isMobileMenuOpen ? 'openMobileMenu' : 'closeMobileMenu'],
          )}
          className="menu-trigger"
        >
          <Icon name="manage_search" />
        </Button>
      </div>

      <MobileNavigationBody
        onToggleMenu={closeMobileMenu}
        title="G20 Brasil 2024"
        active={isMobileMenuOpen}
        menu-label={intl.formatMessage(messages.menu_label)}
        close-label={intl.formatMessage(messages.closeMobileMenu)}
      >
        {/* Lateral */}
        <MobileNavigationBody.Group items={items} lang={lang} />

        {/* <MobileNavigationBody.Footer>
          <SocialLinks />
        </MobileNavigationBody.Footer> */}

        {/* Vertical */}
        {/* {items.map(item=>{
          return <MobileNavigation.Group items={item.items} lang={lang} collapsible title={item.title} description={item.description} />
        })} */}
      </MobileNavigationBody>
    </nav>
  );
};

Navigation.propTypes = {
  pathname: PropTypes.string.isRequired,
};

export default Navigation;
